import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { ActionSource } from 'src/app/state/action-sources';

import { MergeConflictFieldOptions, MergeConflictSelection } from './user-page-merge-conflict-dialog.state';

export const UserPageMergeConflictDialogActions = createActionGroup({
    source: ActionSource.USER_PAGE_MERGE_CONFLICT_DIALOG,
    events: {
        'Dialog Opened': props<{
            primaryId: string;
            duplicateId: string;
            company?: MergeConflictFieldOptions;
            billingAddress?: MergeConflictFieldOptions;
        }>(),
        'Company Option Selected': props<{ option: MergeConflictSelection }>(),
        'Billing Address Option Selected': props<{ option: MergeConflictSelection }>(),
        'Cancel Button Clicked': emptyProps(),
        'Confirm Button Clicked': emptyProps(),
        'Merge Users Success': emptyProps(),
        'Merge Users Error': props<{ error: Error }>(),
    },
});
